import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .super-category-rail {
    background-color: ${getColor(COLOR_DICTIONARY.MOVISTAR_BLUE)};
    width: 100%;
    padding: 12px 0px;
    margin-top: 14px;
  }

  .super-category-rail__items {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    list-style: none;
  }

  .super-category-rail__items::-webkit-scrollbar {
    display: none;
  }

  .super-category-rail__item {
    flex-shrink: 0;
    &--selected {
      flex-shrink: 0;
    }
  }

  :global(.super-category-rail__item-link) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    background-color: ${getColor(COLOR_DICTIONARY.WHITE)};
    border-radius: 100px;
    padding: 4px 16px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.15s ease, border-color 0.15s ease;
    border: 1px solid ${getColor(COLOR_DICTIONARY.GREY_500)};
    outline: none;
  }

  :global(.super-category-rail__item-link:hover) {
    background-color: ${getColor(COLOR_DICTIONARY.BLUE_LIGHT)};
    border-color: ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
  }

  :global(.super-category-rail__item-link:focus-visible) {
    outline: 2px solid ${getColor(COLOR_DICTIONARY.WHITE)};
    outline-offset: 2px;
    box-shadow: 0 0 0 4px ${getColor(COLOR_DICTIONARY.BLUE_HIGH)};
  }

  :global(.super-category-rail__item--selected .super-category-rail__item-link) {
    background-color: ${getColor(COLOR_DICTIONARY.BLUE_LIGHT)};
    border: 1px solid ${getColor(COLOR_DICTIONARY.BLUE_LIGHT)};
  }

  .super-category-rail__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;
